import request from '@/utils/request.js'

const hostUrl = process.env.VUE_APP_FILE_API

// 获取服务器ali-oss的签名
export function signatureApi(platform, data) {
  return request(
    {
      url: hostUrl + `/attachments/upload-policy`,
      method: 'post',
      data: { platform, ...data }
    },
    { needLoading: false }
  )
}

// 获取资源上传凭证
export function getUploadPolicy() {
  return request(
    {
      url: hostUrl + '/resources/upload-policy',
      method: 'post'
    },
    { needLoading: false }
  )
}

// 上传文件到ali-oss
export function uploadFileApi(url, data, progressEvent) {
  return request(
    {
      url: url,
      headers: { 'Content-Type': 'multipart/form-data' },
      method: 'post',
      withCredentials: false,
      onUploadProgress: progressEvent,
      data
    },
    { needLoading: false, isFormData: true }
  )
}

// 上传文件前，获取文件组groupId
export function getGroupApi(data) {
  return request(
    {
      url: hostUrl + `/attachment-groups`,
      method: 'post',
      data
    },
    { needLoading: false }
  )
}

// 通过groupId获取到文件列表
export function getFileListByGroupIdApi(params) {
  return request(
    {
      url: hostUrl + `/attachment-groups/${params.groupId}/attachments`,
      method: 'get'
    },
    { needLoading: false }
  )
}

// 查询附件信息列表
export function getFileListByFileIdsApi(params) {
  return request(
    {
      url: `${hostUrl}/attachments`,
      method: 'get',
      params: { attachmentIds: params.attachmentIds }
    },
    { needLoading: false }
  )
}

// 根据业务fileId获取文件地址，下载和预览场景使用：目前图片上传也使用该接口
export function getFileUrlByFileIdApi(params) {
  return request(
    {
      url: hostUrl + `/attachments/${params.attachmentId}/access-url`,
      method: 'get'
    },
    { needLoading: false }
  )
}

// 获取WPS的预览地址
export function getFilePreviewUrlApi(attachmentId, pattern) {
  return request(
    {
      url: `${hostUrl}/attachments/${attachmentId}/patterns/${pattern}/preview-url`,
      method: 'get'
    },
    {
      needLoading: false
    }
  )
}

// 删除文件
export function deleteFileApi(data) {
  return request(
    {
      url: hostUrl + `/attachments/${data.attachmentId}`,
      method: 'delete'
    },
    {
      needLoading: true
    }
  )
}
